import React, { useState, useEffect } from 'react';
import Flex from '../../components/Flex';
import Text from '../../components/Text';
import LocalizedText from 'src/components/LocalizedText';
import DashboardLoader from './styles';
import sgeLoader from 'src/assets/loaders/sge-loader.json';
import { LottieRefCurrentProps, useLottie } from 'lottie-react';

const loadingMessages = ['screenDashboardAndLogging', 'screen2', 'screen3', 'screen4', 'screen5', 'screen6'];

const loadingStatesMessage = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    let timeout: any = null;
    if (messageIndex < loadingMessages.length - 1) {
      timeout = setTimeout(() => setMessageIndex(messageIndex + 1), 4000);
    }
    return () => clearTimeout(timeout);
  }, [loadingMessages, messageIndex]);

  return `loading.${loadingMessages[messageIndex]}`;
};

export const UserLoader = () => {
  const lottieRef = React.useRef<LottieRefCurrentProps>(null);

  const options = {
    animationData: sgeLoader,
    lottieRef
  };

  const { View, animationItem } = useLottie(options);
  React.useEffect(() => {
    animationItem?.setSpeed(0.5);
  }, [animationItem]);

  return (
    <DashboardLoader.Container>
      <Flex justifyContent="space-around" alignSelf="center" alignItems="center" mobile fullWidth>
        <Flex style={{ maxWidth: 250 }}>{View}</Flex>
        <DashboardLoader.Text>
          <Text.H6 weight="bold">
            <LocalizedText id={loadingStatesMessage()} description="Loading" />
          </Text.H6>
        </DashboardLoader.Text>
      </Flex>
    </DashboardLoader.Container>
  );
};

export default React.memo(UserLoader);
